<div class="dialog" *ngIf="isModal">
    <div class="modal-header">
        <img class="modal-close" (click)="closeModal()" />
        <h4 class="modal-title text-center obfuscated-playback">RM Check-In</h4>
    </div>
    <div class="modal-body obfuscated-playback">
        <div class="modal-body-qr">
            <qrcode [qrdata]="qrData" [ariaLabel]="'QR Code image with the following content...'"
                [cssClass]="'demoBorderRadius'" [colorDark]="'#02a844'" [colorLight]="'#ffffff'"
                [elementType]="'canvas'" [errorCorrectionLevel]="'M'" [margin]="4" [scale]="8"
                [title]="'A custom title attribute'" [width]="200">
            </qrcode>
            <img class="qr-image" src="../../assets/images/scan_me.svg" alt="">
        </div>
    </div>
    <div class="modal-footer-qr">
        <button class="btn btn-success" (click)="closeModal()">Ok</button>
    </div>
</div>

<div class="qrcodeImage" *ngIf="!isModal">
    <qrcode [qrdata]="qrData" [ariaLabel]="'QR Code image with the following content...'"
        [cssClass]="'demoBorderRadius'" [colorDark]="'#02a844'" [colorLight]="'#ffffff'" [elementType]="'canvas'"
        [errorCorrectionLevel]="'M'" [margin]="4" [scale]="8" [title]="'A custom title attribute'" [width]="200">
    </qrcode>
</div>
